var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userId !== null && _vm.paidTime > 0)?_c('span',[_c('span',[_vm._v(_vm._s(_vm.prefix)),_c('strong',[_vm._v(_vm._s(_vm.paidTime))]),_vm._v(_vm._s(_vm.suffix))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }